import {
    QUALIFIES_LIST_REQUEST,
    QUALIFIES_LIST_SUCCESS,
    QUALIFIES_LIST_FAIL,
  } from "../constant/QualifiesConstant";

  export const qualifiesListReducer = (state = {}, action) => {
    switch (action.type) {
      case QUALIFIES_LIST_REQUEST:
        return { loading: true };
      case QUALIFIES_LIST_SUCCESS:
        return { loading: false, qualifiesRecords: action.payload };
      case QUALIFIES_LIST_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };